import * as React from "react";
export const ErrorListItem = ({ className, source, error, onErrorClick }) => {
    const handleClick = () => {
        onErrorClick(source, error);
    };
    const text = source ? source + ": " + error : error;
    const classType = className
        ? className + " text-danger"
        : "list-group-item text-danger";
    return (React.createElement("li", { className: classType, onClick: onErrorClick ? handleClick : null }, text));
};
//# sourceMappingURL=ErrorListItem.js.map